import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, NO_ACCESS_MESSAGE, hasAnyRequiredActionsInAnySpace } from "utils/access";
import { Action } from "types/generated";

export const TERRAFORM_PROVIDER_CREATE_ACCESS_TYPES = [
  Action.SpaceAdmin,
  Action.TerraformProviderCreate,
];

/**
 * Hook that returns whether current user can create terraform providers
 * User needs to have SpaceAdmin or TerraformProviderCreate actions in at least one space
 * @returns {AccessResult} Object indicating if user can create worker pools and a message if not
 */
const useCanCreateTerraformProvider = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = hasAnyRequiredActionsInAnySpace(TERRAFORM_PROVIDER_CREATE_ACCESS_TYPES, viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateTerraformProvider;
